import emailjs from '@emailjs/browser';
import { format } from 'date-fns';

const EMAIL_SERVICE_ID = 'service_l3m3m0p';
const ADMIN_TEMPLATE_ID = 'template_7djnxlw';
const CUSTOMER_TEMPLATE_ID = 'template_nnng2fs';
const EMAIL_PUBLIC_KEY = 'B-OLwAMJiQ94ehf7y';
const ADMIN_EMAIL = 'highlinehoodies@gmail.com';

const formatOrderItems = (items) => {
  return items.map(item => `
    ${item.quantity}x ${item.size} ${item.type}
    Color: ${item.color}
    
    Files:
    ${item.uploadedFiles?.map(file => `- ${file.originalName}: ${file.downloadURL}`).join('\n')}
    
    ${item.preview ? `Preview: ${item.preview.downloadURL}` : ''}
    
    Notes:
    ${item.notes?.front ? `Front: ${item.notes.front}` : ''}
    ${item.notes?.back ? `Back: ${item.notes.back}` : ''}
  `).join('\n\n');
};

const formatDeliveryInfo = (delivery) => {
  if (delivery.method === 'pickup') {
    return 'Local Pickup';
  }
  
  const address = delivery.shippingAddress;
  return `
    Shipping Address:
    ${address.street}
    ${address.city}, ${address.state} ${address.zip}
  `;
};

export const sendOrderNotification = async (orderData) => {
  try {
    // Admin notification
    await emailjs.send(
      EMAIL_SERVICE_ID,
      ADMIN_TEMPLATE_ID,
      {
        to_email: ADMIN_EMAIL,
        from_name: 'Highline Apparel Website',
        customer_name: orderData.name,
        customer_email: orderData.email,
        order_id: orderData.orderId,
        order_date: format(new Date(), 'PPpp'),
        company: orderData.company || 'N/A',
        phone: orderData.phone || 'N/A',
        order_items: formatOrderItems(orderData.orderItems),
        delivery_info: formatDeliveryInfo(orderData.delivery)
      },
      EMAIL_PUBLIC_KEY
    );

    // Customer confirmation - send to customer's email
    await emailjs.send(
      EMAIL_SERVICE_ID,
      CUSTOMER_TEMPLATE_ID,
      {
        to_name: orderData.name,
        to_email: orderData.email, // This should be used in the EmailJS template
        customer_email: orderData.email, // Backup in case template uses this variable
        order_id: orderData.orderId,
        order_date: format(new Date(), 'PPpp'),
        order_summary: orderData.orderItems.map(item => 
          `${item.quantity}x ${item.size} ${item.type}`
        ).join('\n')
      },
      EMAIL_PUBLIC_KEY
    );
    
    return true;
  } catch (error) {
    console.error('Email send error:', error);
    throw error;
  }
};